import { createFileRoute, redirect } from '@tanstack/react-router';

import { AppShell } from '@/app/shell/AppShell';
import { ApiError } from '@/lib/api/errors';
import { sessionQueryOptions } from '@/lib/session/session-queries';
import { useAuthStore } from '@/lib/session/auth-store';
import { telemetry } from '@/lib/telemetry';

/*
 * Session gate (spec §3.6, §4.2). beforeLoad runs outside React: it primes /me
 * via the query cache on cold arrival, derives the session, and writes it to
 * the auth store so child guards can read it imperatively. A 401 redirects to
 * login with the attempted path preserved.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context, location }) => {
    try {
      const session =
        await context.queryClient.ensureQueryData(sessionQueryOptions);
      useAuthStore.getState().setSession(session);
      // Attribute RUM to the opaque user id on cold bootstrap (§13), so a
      // page loaded directly (not via the login form) is still attributed.
      telemetry.setUser(session.id);
      return { session };
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        useAuthStore.getState().clear();
        throw redirect({
          to: '/login',
          search: { redirect: location.href },
        });
      }
      throw error;
    }
  },
  component: AppShell,
});
